// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Candidates_container__qgrWa {
  padding: 20px;
}

.Candidates_controls__60t7N {
   display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.Candidates_kanbanView__BibWs {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 20px;
}

.Candidates_kanbanColumn__pO3CA {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
}

.Candidates_kanbanColumn__pO3CA h3 {
  margin-top: 0;
  text-align: center;
}

.Candidates_kanbanCards__OB0hp {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 15px;
}

.Candidates_kanbanCard__N8BeH {
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: white;
}

.Candidates_kanbanCardContent__Ksl2c {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.Candidates_kanbanCardMeta__PPGJp {
  display: flex;
  justify-content: space-between;
  font-size: 0.8em;
  color: #666;
}
.Candidates_kanbanColumnHeader__gBC6I {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #dee2e6;
}

.Candidates_countBadge__3OwIY {
  background: #6c757d;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8em;
}

.Candidates_kanbanActions__r8ONY {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 10px;
}

.Candidates_kanbanActions__r8ONY button {
  width: 100%;
  padding: 5px;
  font-size: 0.8em;
}

.Candidates_controls__60t7N > h1 {
  margin: 0;
  margin-right: auto;
}

.Candidates_controls__60t7N {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.Candidates_candidate-details__wjrCM {
  margin-top: 16px;
  padding: 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
}

.Candidates_candidate-details__wjrCM h4 {
  margin-top: 0;
  margin-bottom: 8px;
}

.Candidates_candidate-details__wjrCM p {
  margin-bottom: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/Candidates/Candidates.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;GACG,aAAa;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".container {\n  padding: 20px;\n}\n\n.controls {\n   display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.kanbanView {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 20px;\n}\n\n.kanbanColumn {\n  background: #f8f9fa;\n  padding: 15px;\n  border-radius: 8px;\n}\n\n.kanbanColumn h3 {\n  margin-top: 0;\n  text-align: center;\n}\n\n.kanbanCards {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.kanbanCard {\n  padding: 15px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background: white;\n}\n\n.kanbanCardContent {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.kanbanCardMeta {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.8em;\n  color: #666;\n}\n.kanbanColumnHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.countBadge {\n  background: #6c757d;\n  color: white;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8em;\n}\n\n.kanbanActions {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-top: 10px;\n}\n\n.kanbanActions button {\n  width: 100%;\n  padding: 5px;\n  font-size: 0.8em;\n}\n\n.controls > h1 {\n  margin: 0;\n  margin-right: auto;\n}\n\n.controls {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.candidate-details {\n  margin-top: 16px;\n  padding: 12px;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.candidate-details h4 {\n  margin-top: 0;\n  margin-bottom: 8px;\n}\n\n.candidate-details p {\n  margin-bottom: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Candidates_container__qgrWa`,
	"controls": `Candidates_controls__60t7N`,
	"kanbanView": `Candidates_kanbanView__BibWs`,
	"kanbanColumn": `Candidates_kanbanColumn__pO3CA`,
	"kanbanCards": `Candidates_kanbanCards__OB0hp`,
	"kanbanCard": `Candidates_kanbanCard__N8BeH`,
	"kanbanCardContent": `Candidates_kanbanCardContent__Ksl2c`,
	"kanbanCardMeta": `Candidates_kanbanCardMeta__PPGJp`,
	"kanbanColumnHeader": `Candidates_kanbanColumnHeader__gBC6I`,
	"countBadge": `Candidates_countBadge__3OwIY`,
	"kanbanActions": `Candidates_kanbanActions__r8ONY`,
	"candidate-details": `Candidates_candidate-details__wjrCM`
};
export default ___CSS_LOADER_EXPORT___;
